export const InspectionReport = [
	'overview',
	'arrival',
	'site',
	'structures',
	'pdfreview',
	'photoreview',
	'virtualtour'
];
